import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { ThemeSelect } from 'src/editor/shared/ui-lib/theme-select'
import { TextInputControl } from 'src/editor/shared/settings/controls/text-input-control'
import { GhostIconButton } from 'src/editor/shared/ui-lib/buttons'
import { Repeat04Icon } from 'src/editor/shared/icons/repeat-04-icon'
import { useWebsiteThemes } from './hooks/useWebsiteThemes'
import { useWebsiteTheme } from './hooks/useWebsiteTheme'
import { useActions } from 'common/hooks/useActions'
import { fetchWebsiteDraftTheme } from 'src/editor/store/website-settings/website-settings-actions'

interface WebsiteThemeBaseProps {
  onReset: () => void
}

export const WebsiteThemeBase = ({ onReset }: WebsiteThemeBaseProps) => {
  const { t } = useTranslation()
  const [activeThemeId, setActiveThemeId] = useState<number>(1)
  const { data, isLoading, isError, error } = useWebsiteThemes()
  const dispatchFetchWebsiteDraftTheme = useActions(fetchWebsiteDraftTheme)

  const {
    refetch,
    isFetching,
    isError: isErrorTheme,
    error: errorTheme,
  } = useWebsiteTheme(activeThemeId)

  const handleDelete = () => {
    // delete theme
  }

  const handleUpdate = async (id: number) => {
    setActiveThemeId(id)
    const result = await refetch()
    if (result.data) {
      dispatchFetchWebsiteDraftTheme(result.data)
    }
  }

  if (isError || isErrorTheme) {
    return <div>Error: {error?.message || errorTheme?.message}</div>
  }

  return (
    <>
      <GroupTitle
        isFirst
        afterChildren={
          <GhostIconButton onClick={onReset} icon={<Repeat04Icon />} />
        }
        className="flex items-center justify-between"
      >
        {t('Theme')}
      </GroupTitle>
      <ThemeSelect
        themes={data}
        activeThemeId={activeThemeId}
        update={handleUpdate}
        onDelete={handleDelete}
        isLoading={isLoading || isFetching}
      />
      <TextInputControl
        update={() => {}}
        value={''}
        labelText={t('website_theme_settings.name')}
        placeholder={t('website_theme_settings.name_placeholder')}
        required
      />
    </>
  )
}
